module.exports = __webpack_public_path__ + "media/assets/images/flags/iq-5e2bed1bccae5526ec8dd1bd5de3a6fb.svg";